import { useContext, useEffect } from 'react';
import { GlobalMobileContext } from '../contexts/globalMobileContext';

const Mobile_ErrorComponent = () => {

    const { currentError, setCurrentError } = useContext(GlobalMobileContext);

    useEffect(() => {
        setTimeout(() => {
            setCurrentError(null);
        }, 4000);
    }, []);

    return (
        <div className="alert alert-danger alert-dismissible fade show" role="alert" style={{ position:"fixed", zIndex:"99", bottom:"-5px",right:"10px"}}>
            <h4 className="alert-heading">Error</h4>
            <hr />
            <p className="mb-0">{currentError}</p>
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={ () => setCurrentError(null) }></button>
        </div>
    );
}

export default Mobile_ErrorComponent;